import { useTranslation } from "react-i18next"
import { icons } from "@/components"
import type { IMetaTeamFeedback } from "@/types"
import { PreviewRow } from "./PreviewRow"
import { PreviewUsers } from "./PreviewUsers"

export function PreviewPeers({ peers, peer_ids, peer_team_ids }: IMetaTeamFeedback) {
  const { t } = useTranslation()

  return (
    <PreviewRow
      value={
        peers == "all" ? (
          t("All employees")
        ) : peers == "teammates" ? (
          t("Own departments")
        ) : peers == "manager" ? (
          t("Manager & reports")
        ) : peers == "self" ? (
          t("Self review")
        ) : (
          <PreviewUsers method={peers as "all" | "manual"} user_ids={peer_ids} team_ids={peer_team_ids} />
        )
      }
    >
      <icons.Team />
      {t("Peers")}
    </PreviewRow>
  )
}
